import React, { useState } from "react"
import {
  Button,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  TextField,
} from "@mui/material"
import { RepresentantOrganismePublic } from "../../model/RepresentantOrganismePublic"
import DeleteIcon from "@mui/icons-material/Delete"
import { Trans, useTranslation } from "react-i18next"

interface RepresentantOrganismePublicCRUDFormProps {
  representantsOrganismePublic: RepresentantOrganismePublic[]
  onChange: (
    updatedRepresentantsOrganismePublic: RepresentantOrganismePublic[]
  ) => void
}

const RepresentantOrganismePublicCRUDForm: React.FC<
  RepresentantOrganismePublicCRUDFormProps
> = ({ onChange }) => {
  const [items, setItems] = useState<RepresentantOrganismePublic[]>([])
  const [newItem, setNewItem] = useState<RepresentantOrganismePublic>({
    nom: "",
    titre: "",
  })
  const { t } = useTranslation()

  const handleAddItem = async () => {
    setItems([...items, newItem])

    var newItems = items.concat([newItem])
    setItems(newItems)
    onChange(newItems)
    setNewItem({ nom: "", titre: "" })
  }

  const handleDeleteItem = async (index: number) => {
    const updatedItems = [...items]
    updatedItems.splice(index, 1)
    setItems(updatedItems)
    onChange(updatedItems)
  }

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setNewItem((prevItem) => ({ ...prevItem, [name]: value }))
  }

  return (
    <div>
      <FormLabel>
        <Trans>
          {t(
            "formulairePlaintes.renseignementsContextePlainte.lblRepresentantsOP"
          )}
        </Trans>
      </FormLabel>
      <List dense={false}>
        {items.map((item, index) => (
          <FormControl key={index}>
            <ul>
            <ListItem
              secondaryAction={
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => handleDeleteItem(index)}
                >
                  <DeleteIcon />
                </IconButton>
              }
            >
              <ListItemText primary={`${item.nom} - ${item.titre}`} />
            </ListItem>
            </ul>
          </FormControl>
        ))}
      </List>
      <Grid container>
        <Grid item xs={6}>
          <FormControl className="width-98">
            <TextField
              label={
                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsContextePlainte.lblNomRepresentantOP"
                  )}
                </Trans>
              }
              name="nom"
              value={newItem.nom}
              onChange={handleInputChange}
              variant="filled"
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth variant="standard">
            <TextField
              label={
                <Trans>
                  {t(
                    "formulairePlaintes.renseignementsContextePlainte.lblTitreRepresentantOP"
                  )}
                </Trans>
              }
              name="titre"
              value={newItem.titre}
              onChange={handleInputChange}
              variant="filled"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Button className="btnAjout" variant="contained" onClick={handleAddItem}>
            <Trans>
              {t(
                "formulairePlaintes.renseignementsContextePlainte.ctaAjouterRepresentantOP"
              )}
            </Trans>
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

export default RepresentantOrganismePublicCRUDForm